module.exports = __webpack_public_path__ + "img/Feature_3.f3a18d41.svg";